import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import About from '../../components/about/about';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.png'

const AboutPage = () => {
    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />

            <About hclass={'about-section section-padding'} />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default AboutPage;
